// extracted by mini-css-extract-plugin
export var chevron = "_2n-2";
export var chevronCollapsed = "_2n-3";
export var collapsibleHeader = "_2n-1";
export var container = "_2n-0";